const styles = () => ({
    dropZone: {
        minHeight: 'inherit',
    },
    dropZoneHiden: {
        display: 'none',
    },
    dropZoneWrapper: {
        padding: '16px 16px 16px 16px',
        border: '1px solid rgb(189 189 189)',
        borderRadius: '4px',
        width: '100%',
        display: 'inline-block',
    },
    checkboxHelperText: {
        margin: '-5px 0 0 10px',
    },
});

export default styles;



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/paymentApproval/styles.js